import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import loaderPlane from './images/loaderPlane';
import Lottie from 'react-lottie';
import { isMobileOnly } from 'react-device-detect';
import PlaneLoaderAnimation from '../../../animations/plane.json';
import images from './images/images'
import {getMarketCode} from 'app/utilities/domain/domainConstants';
export default function AbroadLoaderAnimation(props) {

  
  const marketCode = getMarketCode().toLowerCase();
  return (
    <>{isMobileOnly ?
      <img src={require(`./images/mobile-loader-GIF-${marketCode}.gif`)} />
      :
      <img src={require(`./images/desktop-loader-GIF-${marketCode}.gif`)} />}
    </>
  );
}
